import Pusher from "pusher-js";
import { APP_PUSHER_KEY } from "@/constants/config";

export const pusher = new Pusher(APP_PUSHER_KEY, {
  cluster: 'eu'
});
